export const PredefinedPortFactory = (ports: any[]) => () => ports;